// extracted by mini-css-extract-plugin
export default {"mainCardContainer":"pageWithCards-module--mainCardContainer--+5zFN","title":"pageWithCards-module--title--Ljcqj","emptyQuery":"pageWithCards-module--emptyQuery--MVctJ"};